import { __assign } from "tslib";
import { useMemo } from 'react';
import { ItemUtils, selectors } from '@marvelapp/design-creator';
import { getExpandedAncestors, getDefaultLayerLabel } from '../utils';
export function useLayerFilter(design, filterText) {
    // Recalculate the filtered items only when the filterText term actually changes
    var filteredItems = useMemo(function () {
        return getFilteredItems(design, filterText);
    }, [design, filterText]);
    // Ensure we always return the same reference
    // to filter if nothing changed
    var filter = useMemo(function () { return ({
        filterText: filterText,
        filteredItems: filteredItems,
    }); }, [filterText, filteredItems]);
    return filter;
}
function getFilteredItems(design, filterText) {
    if (!filterText) {
        return {};
    }
    var allItemIds = Object.keys(selectors.getItems(design));
    // 1. Get item ids for items matching filter term
    var idsMatchingTerm = allItemIds.reduce(function (res, currId) {
        var item = selectors.getItemById(design, currId);
        if (item === null)
            return res;
        var itemName = ItemUtils.getName(item) || getDefaultLayerLabel(item);
        var isMatching = itemName
            .toLowerCase()
            .includes(filterText.toLowerCase());
        if (isMatching) {
            res[currId] = true;
        }
        return res;
    }, {});
    // 2. For each id matching filter, find the item's ancestors and add their ids.
    // We do this because if an item matches a search term it takes all
    // of it's ancestors with it to be displayed.
    var ancestrosOfMatchingIds = getExpandedAncestors(design, Object.keys(idsMatchingTerm));
    return __assign(__assign({}, idsMatchingTerm), ancestrosOfMatchingIds);
}
